import {
  CONFIRMED_GET_DEFAULT_DOSES,
  CONFIRMED_CREATE_DEFAULT_DOSE,
  CONFIRMED_DELETE_DEFAULT_DOSE,
  CONFIRMED_EDIT_DEFAULT_DOSE,
} from "../types/DefaultDoseTypes";

import {
  getDefaultDoses,
  createDefaultDose,
  updateDefaultDose,
  deleteDefaultDose,
  formatDefaultDoses,
} from "../../services/DefaultDoseService";

import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";

// Get Default Doses
export function getDefaultDoseAction(
  pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return async (dispatch) => {
    try {
      const response = await getDefaultDoses(
        pagination,
        pageid,
        search_by,
        search_keyword,
        sort_by,
        sort_order
      );

      if (response?.status === 200 && response.data?.status === "success") {
        const doses = formatDefaultDoses(response.data.data);
        const num_rows = response.data.num_rows || 0;

        dispatch({
          type: CONFIRMED_GET_DEFAULT_DOSES,
          payload: { doses, num_rows },
        });
      } else {
        handleError("Failed to get default doses");
      }
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to get default doses");
    }
  };
}

// Delete Default Dose
export function deleteDefaultDoseAction(defaultDoseId) {
  return async (dispatch) => {
    try {
      await deleteDefaultDose(defaultDoseId);
      dispatch({
        type: CONFIRMED_DELETE_DEFAULT_DOSE,
        payload: { default_dose_id: defaultDoseId },
      });
      handleSuccess("Default Dose deleted successfully!");
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to delete default dose");
    }
  };
}

// Create Default Dose
export function createDefaultDoseAction(defaultDoseData, navigate) {
  return async (dispatch) => {
    try {
      const response = await createDefaultDose(defaultDoseData);

      if (response?.status === 200 && response.data?.status === "success") {
        const formattedDose = formatDefaultDoses([response.data.data])[0];
        dispatch({
          type: CONFIRMED_CREATE_DEFAULT_DOSE,
          payload: formattedDose,
        });
        if (navigate) navigate("/default-dose");
        handleSuccess("Default Dose created successfully!");
      } else {
        showErrorAlert("Failed to create default dose");
      }
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to create default dose");
    }
  };
}

// Update Default Dose
export function updateDefaultDoseAction(defaultDoseData, defaultDoseId, navigate) {
  return async (dispatch) => {
    try {
      const payload = {
        ...defaultDoseData,
        dose_id: defaultDoseId,
      };

      const response = await updateDefaultDose(payload);

      if (response?.status === 200 && response.data?.status === "success") {
        const formattedDose = formatDefaultDoses([response.data.data])[0];
        dispatch({
          type: CONFIRMED_EDIT_DEFAULT_DOSE,
          payload: formattedDose,
        });
        if (navigate) navigate("/default-dose");
        handleSuccess("Default Dose updated successfully!");
      } else {
        showErrorAlert("Failed to update default dose");
      }
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to update default dose");
    }
  };
}
